export const AgentStateIndicator = ({ agentState }: { agentState: string }) => {
	return (
		<div className="mb-6">
			<div className="flex items-center justify-center gap-2 mb-2">
				<div
					className={`w-3 h-3 rounded-full ${
						agentState === 'listening'
							? 'bg-blue-500 animate-pulse'
							: agentState === 'speaking'
								? 'bg-green-500 animate-pulse'
								: agentState === 'thinking'
									? 'bg-yellow-500 animate-pulse'
									: 'bg-gray-400'
					}`}
				/>
				<span className="text-sm font-medium text-gray-700 capitalize">
					{agentState === 'listening'
						? 'Listening to you...'
						: agentState === 'speaking'
							? 'AI is speaking...'
							: agentState === 'thinking'
								? 'AI is thinking...'
								: 'Idle'}
				</span>
			</div>
			<div className="flex items-center justify-center gap-1">
				{agentState === 'listening' && (
					<>
						<div
							className="w-1 h-3 bg-blue-500 rounded-full animate-pulse"
							style={{ animationDelay: '0ms' }}
						/>
						<div
							className="w-1 h-5 bg-blue-500 rounded-full animate-pulse"
							style={{ animationDelay: '150ms' }}
						/>
						<div
							className="w-1 h-4 bg-blue-500 rounded-full animate-pulse"
							style={{ animationDelay: '300ms' }}
						/>
						<div
							className="w-1 h-6 bg-blue-500 rounded-full animate-pulse"
							style={{ animationDelay: '450ms' }}
						/>
						<div
							className="w-1 h-3 bg-blue-500 rounded-full animate-pulse"
							style={{ animationDelay: '600ms' }}
						/>
					</>
				)}
				{agentState === 'speaking' && (
					<>
						<div
							className="w-1 h-4 bg-green-500 rounded-full animate-pulse"
							style={{ animationDelay: '0ms' }}
						/>
						<div
							className="w-1 h-6 bg-green-500 rounded-full animate-pulse"
							style={{ animationDelay: '200ms' }}
						/>
						<div
							className="w-1 h-5 bg-green-500 rounded-full animate-pulse"
							style={{ animationDelay: '400ms' }}
						/>
						<div
							className="w-1 h-7 bg-green-500 rounded-full animate-pulse"
							style={{ animationDelay: '600ms' }}
						/>
						<div
							className="w-1 h-4 bg-green-500 rounded-full animate-pulse"
							style={{ animationDelay: '800ms' }}
						/>
					</>
				)}
				{agentState === 'thinking' && (
					<>
						<div
							className="w-2 h-2 bg-yellow-500 rounded-full animate-bounce"
							style={{ animationDelay: '0ms' }}
						/>
						<div
							className="w-2 h-2 bg-yellow-500 rounded-full animate-bounce"
							style={{ animationDelay: '200ms' }}
						/>
						<div
							className="w-2 h-2 bg-yellow-500 rounded-full animate-bounce"
							style={{ animationDelay: '400ms' }}
						/>
					</>
				)}
			</div>
		</div>
	);
};
